__turbopack_context__.v({
  "builtWith": "ProjectCard-module-scss-module__ZXKq7a__builtWith",
  "buttonGroup": "ProjectCard-module-scss-module__ZXKq7a__buttonGroup",
  "description": "ProjectCard-module-scss-module__ZXKq7a__description",
  "details": "ProjectCard-module-scss-module__ZXKq7a__details",
  "externalLinksGroup": "ProjectCard-module-scss-module__ZXKq7a__externalLinksGroup",
  "mainContent": "ProjectCard-module-scss-module__ZXKq7a__mainContent",
  "projectCard": "ProjectCard-module-scss-module__ZXKq7a__projectCard",
  "projectCardDeck": "ProjectCard-module-scss-module__ZXKq7a__projectCardDeck",
  "technologyList": "ProjectCard-module-scss-module__ZXKq7a__technologyList",
  "thumbnail": "ProjectCard-module-scss-module__ZXKq7a__thumbnail",
  "title": "ProjectCard-module-scss-module__ZXKq7a__title",
});
